import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { WizardComponent } from './wizard.component';

@NgModule({
    imports: [CommonModule, TranslateModule],
    exports: [WizardComponent],
    declarations: [WizardComponent]
})
export class WizardModule {}
